import { SxProps, TableRow, TableRowProps, Theme, useTheme } from "@mui/material"
import { PropsWithChildren } from "react"

export const RPMTableHeaderRow = ({
  children, ...props
}: PropsWithChildren<TableRowProps>) => {

  const theme = useTheme();

  const sx: SxProps<Theme> = {
    ...props.sx,
    backgroundColor: theme.palette.grey[200]
  };

  return (
    <TableRow sx={sx} {...props}>
      {children}
    </TableRow>
  )
}
